import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/admin/clientes.css';
import * as globals from '../../components/GlobalScripts.js';

const Admin_pagos = () => {
    const [accounts, setAccounts] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const get_clients = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/get_clients.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setAccounts(response.data.accounts);
                setTotalPages(response.data.totalPages);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los clientes",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        get_clients(currentPage, search);
    }, [currentPage]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchChangeE = (e) => {
        get_clients(currentPage, e.target.value);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    const handleDelete = (id) => {
        if (!window.confirm("¿Estás seguro que deseas eliminar este cliente?")) {
            return;
        }
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/delete_clients.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Exito",
                    msg: "Cliente eliminado con exito",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                get_clients(currentPage, search);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se elimino el cliente",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al eliminar el cliente",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    return (
        <div className="page-clientes container-section flex-column gap-20">
            <h3>Listado de clientes</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Filtra por nombre:</label>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChangeE(e); }}
                        className="input-primary"
                        placeholder="Preciona enter para buscar"
                    />
                </div>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Correo electronico</th>
                            <th>Ult. actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map(account => (
                            <tr key={account.keylogin}>
                                <td>{account.account.nombre} {account.account.apellidos}</td>
                                <td>{account.email}</td>
                                <td style={{ width: '180px' }}>{account.last_activity}</td>
                                <td className="table-actions" style={{ width: '110px' }}>
                                    <button className="edit-button" onClick={() => navigate(`/admin/clientes/${account.keylogin}`)}>
                                        <svg viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                        </svg>
                                    </button>
                                    <button className="delete-button" onClick={() => handleDelete(account.keylogin)}>
                                        <svg viewBox="0 0 82 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.625 6.25C4.9674 6.25 3.37768 6.90848 2.20558 8.08058C1.03348 9.25268 0.375 10.8424 0.375 12.5V18.75C0.375 20.4076 1.03348 21.9973 2.20558 23.1694C3.37768 24.3415 4.9674 25 6.625 25H9.75V81.25C9.75 84.5652 11.067 87.7446 13.4112 90.0888C15.7554 92.433 18.9348 93.75 22.25 93.75H59.75C63.0652 93.75 66.2446 92.433 68.5888 90.0888C70.933 87.7446 72.25 84.5652 72.25 81.25V25H75.375C77.0326 25 78.6223 24.3415 79.7944 23.1694C80.9665 21.9973 81.625 20.4076 81.625 18.75V12.5C81.625 10.8424 80.9665 9.25268 79.7944 8.08058C78.6223 6.90848 77.0326 6.25 75.375 6.25H53.5C53.5 4.5924 52.8415 3.00269 51.6694 1.83058C50.4973 0.65848 48.9076 0 47.25 0L34.75 0C33.0924 0 31.5027 0.65848 30.3306 1.83058C29.1585 3.00269 28.5 4.5924 28.5 6.25H6.625ZM25.375 31.25C26.2038 31.25 26.9987 31.5792 27.5847 32.1653C28.1708 32.7513 28.5 33.5462 28.5 34.375V78.125C28.5 78.9538 28.1708 79.7487 27.5847 80.3347C26.9987 80.9208 26.2038 81.25 25.375 81.25C24.5462 81.25 23.7513 80.9208 23.1653 80.3347C22.5792 79.7487 22.25 78.9538 22.25 78.125V34.375C22.25 33.5462 22.5792 32.7513 23.1653 32.1653C23.7513 31.5792 24.5462 31.25 25.375 31.25ZM41 31.25C41.8288 31.25 42.6237 31.5792 43.2097 32.1653C43.7958 32.7513 44.125 33.5462 44.125 34.375V78.125C44.125 78.9538 43.7958 79.7487 43.2097 80.3347C42.6237 80.9208 41.8288 81.25 41 81.25C40.1712 81.25 39.3763 80.9208 38.7903 80.3347C38.2042 79.7487 37.875 78.9538 37.875 78.125V34.375C37.875 33.5462 38.2042 32.7513 38.7903 32.1653C39.3763 31.5792 40.1712 31.25 41 31.25ZM59.75 34.375V78.125C59.75 78.9538 59.4208 79.7487 58.8347 80.3347C58.2487 80.9208 57.4538 81.25 56.625 81.25C55.7962 81.25 55.0013 80.9208 54.4153 80.3347C53.8292 79.7487 53.5 78.9538 53.5 78.125V34.375C53.5 33.5462 53.8292 32.7513 54.4153 32.1653C55.0013 31.5792 55.7962 31.25 56.625 31.25C57.4538 31.25 58.2487 31.5792 58.8347 32.1653C59.4208 32.7513 59.75 33.5462 59.75 34.375Z" fill="black" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Admin_pagos;